import { getSite } from './theme';

const PREFIX = 'pickup_card_';

export function saveCardSession(cardNo, cardKey) {
  if (!cardNo || !cardKey) return;
  localStorage.setItem(PREFIX + getSite(), JSON.stringify({ cardNo, cardKey }));
}

export function getCardSession() {
  try {
    const raw = localStorage.getItem(PREFIX + getSite());
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.cardNo || !data?.cardKey) return null;
    return data;
  } catch {
    return null;
  }
}

export function clearCardSession() {
  localStorage.removeItem(PREFIX + getSite());
}

export async function tryEnterLogistics(router) {
  const saved = getCardSession();
  if (!saved) return false;

  const site = getSite();
  try {
    const res = await fetch('/api/verify-card', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cardNo: saved.cardNo, cardKey: saved.cardKey, site })
    });
    const data = await res.json();
    if (data.code === 200 && data.data?.status === 'active') {
      sessionStorage.setItem('site', site);
      sessionStorage.setItem('cardInfo', JSON.stringify(data.data));
      router.replace('/logistics?cardNo=' + data.data.cardNo);
      return true;
    }
    clearCardSession();
  } catch {
    /* keep saved credentials for retry */
  }
  return false;
}
